import { application } from './application';

import { registerControllers } from '~/utils/stimulus';

const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
registerControllers(application, controllers);

const componentControllers = import.meta.glob('../../components/**/controller.js', { eager: true });
registerControllers(application, componentControllers);
